// src/locales/en.json
var en_default = {
  title: "Color Chooser App",
  instructions: "Edit <1>src/App.js</1> and save to reload.",
  learnReact: "Learn React",
  currentColor: "Current color:",
  colors: {
    turquoise: "Turquoise",
    red: "Red",
    yellow: "Yellow"
  },
  languageSelector: "Select Language",
  changeColor: "Change background to",
  add: "+ Add color",
  loading: "Loading colors...",
  remove: "Remove color",
  confirmTitle: "Delete color?",
  confirmBody: "Are you sure you want to delete <b>{{name}}</b>? This cannot be undone.",
  cancel: "Cancel",
  delete: "Delete",
  deleting: "Deleting\u2026",
  errors: {
    loadColors: "Failed to load colors",
    loadColor: "Failed to load color: {{name}}",
    network: "Network error \u2014 could not reach the server.",
    conflict: 'A color named "{{name}}" already exists.',
    rateLimit: "Too many requests. Try again in a moment.",
    server: "Server error. Please try again.",
    deleteNetwork: "Network error \u2014 could not delete color."
  },
  colorPicker: {
    title: "Add a color",
    dialogAriaLabel: "Add custom color",
    closeAriaLabel: "Close",
    hueLabel: "Hue",
    saturationLabel: "Saturation",
    lightnessLabel: "Lightness",
    nameLabel: "Name",
    namePlaceholder: "e.g. Ocean",
    hexLabel: "Hex",
    cancel: "Cancel",
    addColor: "Add color",
    saving: "Saving\u2026",
    errors: {
      nameRequired: "Name is required",
      nameInvalid: "Letters, numbers, spaces, + only",
      nameDuplicate: '"{{name}}" already exists',
      hexFormat: "Use format #RRGGBB"
    }
  }
};

// src/locales/es.json
var es_default = {
  title: "Aplicaci\xF3n de elecci\xF3n de color",
  instructions: "Edita <1>src/App.js</1> y guarda para recargar.",
  learnReact: "Aprender React",
  currentColor: "Color actual:",
  colors: {
    turquoise: "Turquesa",
    red: "Rojo",
    yellow: "Amarillo"
  },
  languageSelector: "Seleccionar Idioma",
  changeColor: "Cambiar el fondo a",
  add: "+ A\xF1adir color",
  loading: "Cargando colores...",
  remove: "Eliminar color",
  confirmTitle: "\xBFEliminar color?",
  confirmBody: "\xBFSeguro que quieres eliminar <b>{{name}}</b>? Esta acci\xF3n no se puede deshacer.",
  cancel: "Cancelar",
  delete: "Eliminar",
  deleting: "Eliminando\u2026",
  errors: {
    loadColors: "No se pudieron cargar los colores",
    loadColor: "No se pudo cargar el color: {{name}}",
    network: "Error de red \u2014 no se pudo conectar al servidor.",
    conflict: 'Ya existe un color llamado "{{name}}".',
    rateLimit: "Demasiadas solicitudes. Int\xE9ntalo de nuevo en un momento.",
    server: "Error del servidor. Int\xE9ntalo de nuevo.",
    deleteNetwork: "Error de red \u2014 no se pudo eliminar el color."
  },
  colorPicker: {
    title: "A\xF1adir un color",
    dialogAriaLabel: "A\xF1adir color personalizado",
    closeAriaLabel: "Cerrar",
    hueLabel: "Tono",
    saturationLabel: "Saturaci\xF3n",
    lightnessLabel: "Luminosidad",
    nameLabel: "Nombre",
    namePlaceholder: "p. ej. Oc\xE9ano",
    hexLabel: "Hex",
    cancel: "Cancelar",
    addColor: "A\xF1adir color",
    saving: "Guardando\u2026",
    errors: {
      nameRequired: "El nombre es obligatorio",
      nameInvalid: "Solo letras, n\xFAmeros, espacios y +",
      nameDuplicate: '"{{name}}" ya existe',
      hexFormat: "Usa el formato #RRGGBB"
    }
  }
};

// src/locales/el.json
var el_default = {
  title: "\u0395\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE\u03C2 \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2",
  instructions: "\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03BF <1>src/App.js</1> \u03BA\u03B1\u03B9 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7.",
  learnReact: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 React",
  currentColor: "\u03A4\u03C1\u03AD\u03C7\u03BF\u03BD \u03C7\u03C1\u03CE\u03BC\u03B1:",
  colors: {
    turquoise: "\u03A4\u03B9\u03C1\u03BA\u03BF\u03C5\u03AC\u03B6",
    red: "\u039A\u03CC\u03BA\u03BA\u03B9\u03BD\u03BF",
    yellow: "\u039A\u03AF\u03C4\u03C1\u03B9\u03BD\u03BF"
  },
  languageSelector: "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u0393\u03BB\u03CE\u03C3\u03C3\u03B1\u03C2",
  changeColor: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03C6\u03CC\u03BD\u03C4\u03BF\u03C5 \u03C3\u03B5",
  add: "+ \u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2",
  loading: "\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03C7\u03C1\u03C9\u03BC\u03AC\u03C4\u03C9\u03BD...",
  remove: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2",
  confirmTitle: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2;",
  confirmBody: "\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03B1 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03C4\u03BF <b>{{name}}</b>; \u0397 \u03B5\u03BD\u03AD\u03C1\u03B3\u03B5\u03B9\u03B1 \u03B4\u03B5\u03BD \u03B1\u03BD\u03B1\u03B9\u03C1\u03B5\u03AF\u03C4\u03B1\u03B9.",
  cancel: "\u0386\u03BA\u03C5\u03C1\u03BF",
  delete: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE",
  deleting: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE\u2026",
  errors: {
    loadColors: "\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2 \u03C7\u03C1\u03C9\u03BC\u03AC\u03C4\u03C9\u03BD",
    loadColor: "\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2 \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2: {{name}}",
    network: "\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5 \u2014 \u03B4\u03B5\u03BD \u03AE\u03C4\u03B1\u03BD \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE.",
    conflict: "\u03A5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03AE\u03B4\u03B7 \u03AD\u03BD\u03B1 \u03C7\u03C1\u03CE\u03BC\u03B1 \u03BC\u03B5 \u03C4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \xAB{{name}}\xBB.",
    rateLimit: "\u03A0\u03BF\u03BB\u03BB\u03AC \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1. \u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03C3\u03B5 \u03BB\u03AF\u03B3\u03BF.",
    server: "\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE. \u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.",
    deleteNetwork: "\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5 \u2014 \u03B4\u03B5\u03BD \u03AE\u03C4\u03B1\u03BD \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03C4\u03BF\u03C5 \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2."
  },
  colorPicker: {
    title: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2",
    dialogAriaLabel: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03BF\u03C3\u03BC\u03AD\u03BD\u03BF\u03C5 \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2",
    closeAriaLabel: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF",
    hueLabel: "\u0391\u03C0\u03CC\u03C7\u03C1\u03C9\u03C3\u03B7",
    saturationLabel: "\u039A\u03BF\u03C1\u03B5\u03C3\u03BC\u03CC\u03C2",
    lightnessLabel: "\u03A6\u03C9\u03C4\u03B5\u03B9\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1",
    nameLabel: "\u038C\u03BD\u03BF\u03BC\u03B1",
    namePlaceholder: "\u03C0.\u03C7. \u03A9\u03BA\u03B5\u03B1\u03BD\u03CC\u03C2",
    hexLabel: "Hex",
    cancel: "\u0386\u03BA\u03C5\u03C1\u03BF",
    addColor: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2",
    saving: "\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7\u2026",
    errors: {
      nameRequired: "\u03A4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03CC",
      nameInvalid: "\u039C\u03CC\u03BD\u03BF \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03B1, \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03AF, \u03BA\u03B5\u03BD\u03AC \u03BA\u03B1\u03B9 +",
      nameDuplicate: "\xAB{{name}}\xBB \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03AE\u03B4\u03B7",
      hexFormat: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03BC\u03BF\u03C1\u03C6\u03AE #RRGGBB"
    }
  }
};

export {
  en_default,
  es_default,
  el_default
};
